module.exports = __webpack_public_path__ + "img/17Johnson.a178558d.png";